/**
 * Document path validation.
 *
 * Validation uses the regex from app settings (documentPathRegex) so the
 * backend and frontend stay in sync. A valid path accepts lowercase letters (a-z),
 * digits, `/` for deeper paths, and - ( ).
 *
 * @param path - Path to validate (will be trimmed)
 * @param documentPathRegex - Regex source string from app settings (e.g. from useAppSettings().documentPathRegex)
 */
export function isValidDocumentPath(
  path: string,
  documentPathRegex: string,
): boolean {
  const trimmed = path.trim();
  if (!trimmed) return false;
  try {
    return new RegExp(documentPathRegex).test(trimmed);
  } catch {
    return false;
  }
}

/** Human-readable description of allowed path format (for error messages). */
export const DOCUMENT_PATH_DESCRIPTION =
  'Use lowercase letters, numbers, / for deeper paths, and - ( ). No leading/trailing slashes.';
